const KEY = "sitako.session";

export const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
};
export const getToken = () => getSession()?.token || null;
export const setSession = (s) => localStorage.setItem(KEY, JSON.stringify(s));
export const clearToken = () => localStorage.removeItem(KEY);
